export default "__VITE_ASSET__CFr6s8l___"